export enum EDocumentType {
  PASSPORT = 'PASSPORT',
  VISA = 'VISA',
  PILOT_CERTIFICATE = 'PILOT_CERTIFICATE',
  MEDICAL_CERTIFICATE = 'MEDICAL_CERTIFICATE'
}
